module.exports = __webpack_public_path__ + "fa2772327f55d8198301fdb8bcfc8158.woff"


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
 ** module id = 7
 ** module chunks = 0 1
 **/